import { useEffect } from "react";
import { api } from "@/lib/api";

/**
 * Detect `?ref=<code>` on any page load and, if present, register a click.
 * Server sets the swingtrust_ref cookie (HttpOnly=false, 30d) — first-touch
 * attribution: existing valid cookie will NOT be overwritten server-side.
 */
export function useRefTracking() {
    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            const ref = params.get("ref");
            if (!ref) return;
            api.trackAffiliateClick(ref, window.location.pathname).catch(() => { /* silent */ });
            // Clean the URL so ?ref= doesn't stick around in the address bar.
            params.delete("ref");
            const clean = window.location.pathname + (params.toString() ? `?${params.toString()}` : "") + window.location.hash;
            window.history.replaceState({}, "", clean);
        } catch {
            /* ignore */
        }
    }, []);
}
